export const LOAD__PROGRESS_PHOTOS = 'LOAD__PROGRESS_PHOTOS';
export const ADD__PROGRESS_PHOTO = 'ADD__PROGRESS_PHOTO';
export const DELETE__PROGRESS_PHOTO = 'DELETE__PROGRESS_PHOTO';